import { SVGProps } from 'react';

const InfinityIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 16c5 0 7-8 12-8a4 4 0 1 1 0 8c-5 0-7-8-12-8a4 4 0 0 0 0 8"
    />
  </svg>
);
export default InfinityIcon;
